var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wysiwyg-editor-field"},[_c('QuillDescriptionEditor',{attrs:{"value":_vm.value,"id":_vm.fieldKey,"options":_vm.editorOption},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }